import api from 'api';

export const loadSharedAccountsLookalikeAudience = api(
  'GET /api/lookalikes-audiences/:lookalikeAudience/shared-accounts'
);

export const createSharedAccountLookalikeAudience = api(
  'POST /api/lookalikes-audiences/:lookalikeAudience/shared-accounts'
);

export const deleteSharedAccountLookalikeAudience = api(
  'DELETE /api/lookalikes-audiences/:lookalikeAudience/shared-accounts/:id'
);

export const loadUnusedAccountsLookalikeAudience = api(
  'GET /api/lookalikes-audiences/:lookalikeAudience/shared-accounts/fields/accounts'
);
